export default __webpack_public_path__ + "static/media/spiritual.1e2d6aae.svg";